import hrms32eLabels from 'assets/labels/hrms32e'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hrms32eLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    let typchg = ''
    const mockTyp = [ '1', '2', '3', '4', '5', '6' ]
    const mockDescTyp = {
      '1': '1ชื่อพนักงาน',
      '2': '2ข้อมูลส่วนตัว',
      '3': '3ข้อมูลการศึกษา',
      '4': '4ข้อมูลบุตร',
      '5': '5ข้อมูลคุณความดี',
      '6': '6ข้อมูลการฝึกอบรม'
    }
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 10
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      typchg = mockTyp[Math.floor(Math.random() * 6)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment(faker.date.past()).format('DD/MM/YYYY'),
        typchg: typchg,
        desc_typchg: mockDescTyp[typchg],
        numseq: faker.random.number().toString().substr(0, 1),
        status: mockStatus[staappr],
        remarkap: 'Test HRES32E',
        codappr: faker.name.findName(),
        next_appr: faker.name.findName(),
        staappr: mockStaappr[Math.floor(Math.random() * 1)],
        codinput: '',
        dteinput: '',
        dtecancel: '',
        codapp: '',
        codempid_query: faker.lorem.word(),
        desc_codempid_query: faker.name.findName()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detailIndex () {
    let mockIndex = {
      namtitlt: 'Mr.',
      namfirstt: faker.name.firstName(),
      namlastt: faker.name.lastName(),
      codcomp: faker.company.companyName(),
      codpos: faker.name.jobType()
    }
    return {
      index: mockIndex
    }
  },
  detailTab1 () {
    let mockTab1 = {
      codtitle: faker.name.prefix(),
      desc_codtitle: faker.random.words(),
      name: faker.name.firstName(),
      last: faker.name.lastName(),
      n_codtitle: faker.name.prefix(),
      n_name: faker.name.firstName(),
      n_last: faker.name.lastName(),
      desnote: '',
      n_codtitle_flg: '',
      n_name_flg: '',
      n_last_flg: '',
      codempid_query: faker.lorem.word()
    }
    return {
      detail1: mockTab1
    }
  },
  detailTab2_6 () {
    let i
    let mockDetail2Tab1 = {
      adrreg: faker.address.secondaryAddress(),
      codsubdistr: '0101',
      coddistr: '1024',
      codprovr: '1000',
      codcntyr: '662',
      codpostr: faker.random.number(),
      adrcont: faker.address.secondaryAddress(),
      codsubdistc: '0100',
      coddistc: '1024',
      codprovc: '1000',
      codcntyc: '662',
      codpostc: faker.random.number(),
      numtelec: faker.phone.phoneNumberFormat(),
      email_emp: faker.internet.email(),
      desc_codsubdistr: '',
      desc_coddistr: '',
      desc_codprovr: '',
      desc_codcntyr: '',
      desc_codsubdistc: '',
      desc_coddistc: '',
      desc_codprovc: '',
      desc_codcntyc: '',
      adrrege_flg: '',
      adrregt_flg: '',
      adrreg3_flg: '',
      adrreg4_flg: '',
      adrreg5_flg: '',
      codsubdistr_flg: '',
      coddistr_flg: '',
      codprovr_flg: '',
      codcntyr_flg: '',
      codpostr_flg: '',
      adrconte_flg: '',
      adrcontt_flg: '',
      adrcont3_flg: '',
      adrcont4_flg: '',
      adrcont5_flg: '',
      codsubdistc_flg: '',
      coddistc_flg: '',
      codprovc_flg: '',
      codcntyc_flg: '',
      codpostc_flg: '',
      numtelec_flg: '',
      email_emp_flg: '',
      codempid_query: faker.lorem.word()
    }

    let mockDetail2Tab2 = {
      numoffid: Math.floor((Math.random() * 9000000000000) + 1),
      adrissue: 'เมือง',
      codprovi: '1000',
      dteoffid: moment().format('DD/MM/YYYY'),
      numlicid: Math.floor((Math.random() * 9000000000000) + 1),
      dtelicid: moment().format('DD/MM/YYYY'),
      numpasid: Math.floor((Math.random() * 9000000000000) + 1),
      dtepasid: moment().format('DD/MM/YYYY'),
      numprmid: Math.floor((Math.random() * 9000000000000) + 1),
      dteprmst: moment().format('DD/MM/YYYY'),
      dteprmen: moment().format('DD/MM/YYYY'),
      stamarry: '1',
      stamilit: '1',
      desc_codprovi: '',
      stamilit_flg: '',
      numoffid_flg: '',
      adrissue_flg: '',
      codprovi_flg: '',
      dteoffid_flg: '',
      numlicid_flg: '',
      dtelicid_flg: '',
      numpasid_flg: '',
      dtepasid_flg: '',
      numprmid_flg: '',
      dteprmst_flg: '',
      dteprmen_flg: '',
      stamarry_flg: '',
      codempid_query: faker.lorem.word()
    }

    let mockDetail2Tab3 = {
      namfathr: faker.name.findName(),
      codfnatn: '01',
      codfrelg: '0001',
      codfoccu: '0005',
      numofidf: Math.floor((Math.random() * 9000000000000) + 1),
      nammothr: faker.name.findName(),
      codmnatn: '01',
      codmrelg: '0002',
      codmoccu: '0005',
      numofidm: Math.floor((Math.random() * 9000000000000) + 1),
      namcont: faker.name.findName(),
      adrcont1: faker.address.streetAddress(),
      codpost: faker.random.number(),
      numtele: faker.phone.phoneNumberFormat(),
      numfax: faker.phone.phoneNumberFormat(),
      email: faker.internet.email(),
      desrelat: 'Test',
      desc_codfnatn: '',
      desc_codfrelg: '',
      desc_codfoccu: '',
      desc_codmnatn: '',
      desc_codmrelg: '',
      desc_codmoccu: '',
      namfathr_flg: '',
      codfnatn_flg: '',
      codfrelg_flg: '',
      codfoccu_flg: '',
      numofidf_flg: '',
      nammothr_flg: '',
      codmnatn_flg: '',
      codmrelg_flg: '',
      codmoccu_flg: '',
      numofidm_flg: '',
      namcont_flg: '',
      adrcont1_flg: '',
      codpost_flg: '',
      numtele_flg: '',
      numfax_flg: '',
      email_flg: '',
      desrelat_flg: '',
      codempid_query: faker.lorem.word()
    }

    let mockDetail2Tab4 = {
      codbank: '0004',
      numbank: Math.floor((Math.random() * 900000000000) + 1),
      codbank2: '',
      numbank2: '',
      amtbank: '100.00',
      desc_codbank: '',
      desc_codbank2: '',
      codbank_flg: '',
      numbank_flg: '',
      codbank2_flg: '',
      numbank2_flg: '',
      amtbank_flg: '',
      codempid_query: faker.lorem.word()
    }

    let mockDetail2Tab5 = {
      codtitle: '1',
      namfirst: faker.name.firstName(),
      namlast: faker.name.lastName(),
      // namspous: faker.name.findName(),
      numspid: Math.floor((Math.random() * 900000000000) + 1),
      dtespbd: moment().format('DD/MM/YYYY'),
      codspocc: '0005',
      desnoffi: faker.address.streetAddress(),
      dtemarry: moment().format('DD/MM/YYYY'),
      desplreg: 'เกาะพีพี',
      codsppro: '1000',
      codspcty: '662',
      desnote: 'Test',
      desc_codspocc: '',
      desc_codsppro: '',
      desc_codspcty: '',
      // namspous_flg: '',
      numspid_flg: '',
      dtespbd_flg: '',
      codspocc_flg: '',
      desnoffi_flg: '',
      dtemarry_flg: '',
      desplreg_flg: '',
      codsppro_flg: '',
      codspcty_flg: '',
      desnote_flg: '',
      codempid_query: faker.lorem.word()
    }

    let mockDetail2Tab6Table1Rows = []
    const mockDetail2Tab6Table1Total = 2
    for (i = 1; i <= mockDetail2Tab6Table1Total; i++) {
      mockDetail2Tab6Table1Rows.push({
        id: i,
        coddeduct: faker.address.countryCode(),
        desdeduct: faker.random.words(),
        amtdeduct: faker.commerce.price(),
        amtdeduct_spous: faker.commerce.price(),
        typdeduct: 'D',
        flg_amtdeduct: '',
        flg_amtdeduct_spous: '',
        flg_new_e: '',
        codempid_query: faker.lorem.word()
      })
    }

    let mockDetail2Tab6Table2Rows = []
    const mockDetail2Tab6Table2Total = 3
    for (i = 1; i <= mockDetail2Tab6Table2Total; i++) {
      mockDetail2Tab6Table2Rows.push({
        id: i,
        coddeduct: faker.address.countryCode(),
        desdeduct: faker.random.words(),
        amtdeduct: faker.commerce.price(),
        amtdeduct_spous: faker.commerce.price(),
        typdeduct: 'E',
        flg_amtdeduct: '',
        flg_amtdeduct_spous: '',
        flg_new_e: '',
        codempid_query: faker.lorem.word()
      })
    }

    let mockDetail2Tab6Table3Rows = []
    const mockDetail2Tab6Table3Total = 2
    for (i = 1; i <= mockDetail2Tab6Table3Total; i++) {
      mockDetail2Tab6Table3Rows.push({
        id: i,
        coddeduct: faker.address.countryCode(),
        desdeduct: faker.random.words(),
        amtdeduct: faker.commerce.price(),
        amtdeduct_spous: faker.commerce.price(),
        typdeduct: 'O',
        flg_amtdeduct: '',
        flg_amtdeduct_spous: '',
        flg_new_e: '',
        codempid_query: faker.lorem.word()
      })
    }

    let mockDetail2Tab7TableRows = []
    const mockDetail2Tab7TableTotal = 1
    for (i = 1; i <= mockDetail2Tab7TableTotal; i++) {
      mockDetail2Tab7TableRows.push({
        numseq: i,
        typdoc: 'RS',
        namtydoc: '',
        namdoc: 'Name Documents',
        dterecv: moment().format('DD/MM/YYYY'),
        dtedocen: moment().format('DD/MM/YYYY'),
        numdoc: faker.random.uuid(),
        filedoc: faker.system.fileName(),
        desnote: 'test',
        status: '',
        desc_status: 'ข้อมูลเดิม',
        p_codempid: '',
        p_dtereq: '',
        p_numseq: '',
        codempid_query: faker.lorem.word()
      })
    }

    let mockTab3Rows = []
    const mockTab3Total = 1
    for (i = 1; i <= mockTab3Total; i++) {
      mockTab3Rows.push({
        numseq: i,
        codedlv: '0003',
        codinst: '0001',
        coddglv: '0002',
        codmajsb: '0004',
        codminsb: '0007',
        numgpa: faker.random.number().toString().substr(0, 1),
        dtegyear: moment().format('YYYY'),
        stayear: moment().format('YYYY'),
        flgeduc: '1',
        codcount: '027',
        staappr: '',
        desc_coddglv: faker.random.words(),
        desc_codmajsb: faker.random.words(),
        desc_codminsb: faker.random.words(),
        desc_codinst: faker.random.words(),
        flgupdat: '',
        status: '',
        desc_status: 'ข้อมูลเดิม',
        codempid_query: faker.lorem.word()
      })
    }

    let mockTab4Rows = []
    const mockTab4Total = 1
    for (i = 1; i <= mockTab4Total; i++) {
      mockTab4Rows.push({
        numseq: i,
        namchild: faker.name.findName(),
        numoffid: Math.floor((Math.random() * 9000000000000) + 1),
        dtechbd: moment().format('DD/MM/YYYY'),
        namsex: 'M',
        flgedlv: 'Y',
        codedlv: '0003',
        desc_codedlv: '',
        flgdeduct: 'Y',
        flgupdat: '',
        staappr: '',
        status: '',
        desc_status: 'ข้อมูลเดิม',
        codempid_query: faker.lorem.word()
      })
    }

    let mockTab5Detail = {
      typrewd: '0001',
      desrewd1: faker.lorem.words(),
      numhmref: faker.random.uuid(),
      typrewd_flg: '',
      desrewd1_flg: '',
      numhmref_flg: '',
      codempid_query: faker.lorem.word()
    }

    let mockTab6Rows = []
    const mockTab6Total = 1
    for (i = 1; i <= mockTab6Total; i++) {
      mockTab6Rows.push({
        numseq: i,
        destrain: faker.name.jobArea(),
        desc_destrain: '',
        dtetr: '',
        dtetrain: moment().format('DD/MM/YYYY'),
        dtetren: moment().format('DD/MM/YYYY'),
        desplace: faker.address.streetAddress(),
        desinstu: faker.company.companyName(),
        flgupdat: '',
        status: '',
        desc_status: 'ข้อมูลเดิม',
        codempid_query: faker.lorem.word()
      })
    }

    return {
      detail2: {
        tab1: mockDetail2Tab1,
        tab2: mockDetail2Tab2,
        tab3: mockDetail2Tab3,
        tab4: mockDetail2Tab4,
        tab5: mockDetail2Tab5,
        tab6: {
          table1: {
            total: mockDetail2Tab6Table1Total,
            rows: mockDetail2Tab6Table1Rows
          },
          table2: {
            total: mockDetail2Tab6Table2Total,
            rows: mockDetail2Tab6Table2Rows
          },
          table3: {
            total: mockDetail2Tab6Table3Total,
            rows: mockDetail2Tab6Table3Rows
          }
        },
        tab7: {
          total: mockDetail2Tab7TableTotal,
          rows: mockDetail2Tab7TableRows
        }
      },
      detail3: {
        total: mockTab3Total,
        rows: mockTab3Rows
      },
      detail4: {
        total: mockTab4Total,
        rows: mockTab4Rows
      },
      detail5: mockTab5Detail,
      detail6: {
        total: mockTab6Total,
        rows: mockTab6Rows
      }
    }
  },
  dropdowns () {
    const mockCodedlv = {
      '0000': 'N/A',
      '0001': 'ปริญญาเอก',
      '0002': 'ปริญญาโท',
      '0003': 'ปริญญาตรี',
      '0004': 'อนุปริญญา',
      '0005': 'ประกาศนียบัตรวิชาชีพ (ปวท.)',
      '0006': 'ประกาศนียบัตรวิชาชีพขั้นสูง (ปวส.)',
      '0007': 'ประกาศนียบัตรวิชาชีพ (ปวช.)',
      '0008': 'มัธยมศึกษาตอนปลาย',
      '0009': 'มัธยมศึกษาตอนต้น',
      '0010': 'ประถมศึกษา'
    }
    const mockCoddglv = {
      '0000': 'ปริญญาเอก',
      '0001': 'การศึกษาบัณฑิต',
      '0002': 'การออกแบบอุตสาหกรรมบัณฑิต',
      '0003': 'เกษตรศาสตรบัณฑิต',
      '0004': 'ครุศาสตรบัณฑิต',
      '0005': 'ครุศาสตรบัณฑิต (พยาบาลศึกษา)',
      '0006': 'ครุศาสตร์อุตสาหกรรมบัณฑิต',
      '0007': 'คหกรรมศาสตรบัณฑิต',
      '0008': 'ทันตแพทยศาสตรบัณฑิต',
      '0009': 'เทคโนโลยีบัณฑิต (เทคโนโลยีสารสนเทศธุรกิจ)',
      '0010': 'นิติศาสตรบัณฑิต'
    }
    const mockCodmajsb = {
      '0001': 'บัญชี',
      '0002': 'การเงินการธนาคาร',
      '0003': 'การตลาด',
      '0004': 'การจัดการ',
      '0005': 'ธุรกิจต่างประเทศ',
      '0006': 'ประชาสัมพันธ์',
      '0007': 'การจัดการการผลิต',
      '0008': 'เศรษศาสตร์การเงิน',
      '0009': 'เศรษศาสตร์ มหาภาค',
      '0010': 'เศรษศาสตร์ระหว่างประเทศ'
    }
    const mockCodminsb = {
      '0000': 'N/A',
      '0001': 'การเงิน การธนาคาร',
      '0002': 'คอมพิวเตอร์ธุรกิจ',
      '0003': 'อิเล็กทรอนิกส์',
      '0004': 'การไฟฟ้า',
      '0005': 'โยธา',
      '0006': 'บัญชี',
      '0007': 'การจัดการ',
      '0008': 'สถาปัตย์',
      '0009': 'วิทยาศาสตร์',
      '0010': 'วิทยาการคอม'
    }
    const mockCodinst = {
      '0000': 'N/A',
      '0001': 'จุฬาลงกรณ์มหาวิทยาลัย',
      '0002': 'มหาวิทยาลัยเกษตรศาสตร์',
      '0003': 'มหาวิทยาลัยขอนแก่น',
      '0004': 'มหาวิทยาลัยเชียงใหม่',
      '0005': 'มหาวิทยาลัยทักษิณ',
      '0006': 'มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี',
      '0007': 'มหาวิทยาลัยเทคโนโลยีสุรนารี',
      '0008': 'มหาวิทยาลัยธรรมศาสตร์',
      '0009': 'มหาวิทยาลัยนเรศวร',
      '0010': 'มหาวิทยาลัยบูรพา'
    }
    const mockCodcount = {
      '027': 'อเมริการใต้',
      '030': 'กรีซ',
      '031': 'เนเธอแลนด์',
      '032': 'เบลเยี่ยม',
      '033': 'ฝรั่งเศส',
      '034': 'สเปน',
      '039': 'อิตาลี',
      '043': 'ออสเตรเลีย',
      '044': 'อังกฤษ',
      '045': 'เดนมาร์ก',
      '046': 'สวีเดน',
      '662': 'ประเทศไทย'
    }
    const mockFlgeduc = {
      '1': 'วุฒิหลัก',
      '2': 'วุฒิรอง'
    }
    const mockTyprewd = {
      '0001': 'รางวัลพนักงานดีเด่น',
      '0002': 'สหกรณ์ออมทรัพย์',
      '0003': 'สหภาพแรงงาน',
      '0004': 'สมาชิกฌาปนกิจสงเคราะห์',
      'M1': 'เสื้อโปโลสีน้ำเงิน',
      'M2': 'เสื้อแจ๊กเก็ต'
    }
    const mockNamsex = {
      'M': 'เพศชาย',
      'F': 'เพศหญิง'
    }
    const mockCodprovr = {
      '1000': 'กรุงเทพมหานคร',
      '1100': 'สมุทรปราการ',
      '1200': 'นนทบุรี',
      '1300': 'ปทุมธานี',
      '1400': 'พระนครศรีอยุธยา',
      '1500': 'อ่างทอง',
      '1600': 'ลพบุรี',
      '1700': 'สิงห์บุรี',
      '1800': 'ชัยนาท',
      '1900': 'สระบุรี',
      '2000': 'ชลบุรี'
    }
    const mockCoddistr = {
      '1021': 'บางขุนเทียน',
      '1024': 'ราษฎร์บูรณะ',
      '1027': 'บึงกุ่ม',
      '1029': 'บางซื่อ',
      '1031': 'บางคอแหลม',
      '1035': 'จอมทอง',
      '1037': 'ราชเทวี',
      '1040': 'บางแค',
      '1043': 'คันนายาว',
      '1045': 'วังทองหลาง',
      '1048': 'ทวีวัฒนา'
    }
    const mockCodsubdistr = {
      '0101': 'บางปะกอก',
      '0100': 'ราษฎร์บูรณะ'
    }
    const mockStamarry = {
      '1': 'โสด',
      '2': 'แต่งงาน',
      '3': 'หย่า',
      '4': 'หม้าย',
      '5': 'สมรสไม่จดทะเบียน'
    }
    const mockStamilit = {
      '1': 'ผ่าน',
      '2': 'ไม่ผ่าน',
      '3': 'อื่นๆ'
    }
    const mockCodfnatn = {
      '0000': 'N/A',
      '0001': 'ไทย',
      '0002': 'จีน',
      '0003': 'อเมริกา',
      '0004': 'อังกฤษ',
      '0005': 'เยอรมัน',
      '0006': 'ญีปุ่น',
      '0007': 'ลาว',
      '01': 'ไทย'
    }
    const mockCodfrelg = {
      '0001': 'พุทธ',
      '0002': 'คริสต์',
      '0003': 'อิสลาม',
      '0004': 'ฮินดู'
    }
    const mockCodfoccu = {
      '0001': 'รับราชการ',
      '0002': 'ค้าขาย',
      '0003': 'ประมง',
      '0004': 'รับจ้าง',
      '0005': 'ธุรกิจส่วนตัว',
      '0006': 'N/A'
    }
    const mockCodbank = {
      '0002': 'ธนาคารกรุงเทพจำกัด(มหาชน)',
      '0004': 'ธนาคารกสิกรไทย',
      '0005': 'ธนาคาร ABN AMRO',
      '0006': 'ธนาคารกรุงไทย',
      '0007': 'แสตนดาร์ดชาร์เตอร์',
      '0008': 'ธนาคารเชส แมนฮัตตัน',
      '0010': 'ธนาคารแห่งโตเกียว มิตซูบิชิ',
      '0011': 'ธนาคารทหารไทย',
      '0012': 'ธนาคาร ดีบีเอส ไทยทนุ',
      '0014': 'ธนาคารไทยพานิชย์'
    }
    const mockTypdoc = {
      'PS': 'testscript',
      'RS': 'resume',
      'TS': 'transript'
    }
    const mockCodtitle = {
      '1': 'นาย',
      '2': 'นาง',
      '3': 'น.ส.',
      '4': 'ด.ช.',
      '5': 'ด.ญ.'
    }
    const mockFlgedlv = {
      'Y': 'ศึกษา',
      'N': 'ไม่ศึกษา'
    }
    const mockFlgdeduct = {
      'Y': 'ใช้',
      'N': 'ไม่ใช้'
    }

    return {
      codedlv: {
        en: mockCodedlv,
        th: mockCodedlv
      },
      coddglv: {
        en: mockCoddglv,
        th: mockCoddglv
      },
      codmajsb: {
        en: mockCodmajsb,
        th: mockCodmajsb
      },
      codminsb: {
        en: mockCodminsb,
        th: mockCodminsb
      },
      codinst: {
        en: mockCodinst,
        th: mockCodinst
      },
      codcount: {
        en: mockCodcount,
        th: mockCodcount
      },
      flgeduc: {
        en: mockFlgeduc,
        th: mockFlgeduc
      },
      typrewd: {
        en: mockTyprewd,
        th: mockTyprewd
      },
      namsex: {
        en: mockNamsex,
        th: mockNamsex
      },
      codprovr: {
        en: mockCodprovr,
        th: mockCodprovr
      },
      coddistr: {
        en: mockCoddistr,
        th: mockCoddistr
      },
      codsubdistr: {
        en: mockCodsubdistr,
        th: mockCodsubdistr
      },
      stamarry: {
        en: mockStamarry,
        th: mockStamarry
      },
      stamilit: {
        en: mockStamilit,
        th: mockStamilit
      },
      codfnatn: {
        en: mockCodfnatn,
        th: mockCodfnatn
      },
      codfrelg: {
        en: mockCodfrelg,
        th: mockCodfrelg
      },
      codfoccu: {
        en: mockCodfoccu,
        th: mockCodfoccu
      },
      codbank: {
        en: mockCodbank,
        th: mockCodbank
      },
      typdoc: {
        en: mockTypdoc,
        th: mockTypdoc
      },
      codtitle: {
        en: mockCodtitle,
        th: mockCodtitle
      },
      flgedlv: {
        en: mockFlgedlv,
        th: mockFlgedlv
      },
      flgdeduct: {
        en: mockFlgdeduct,
        th: mockFlgdeduct
      }
    }
  },
  save () {
    return labels.mockPostMessage
  },
  cancel () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms32e/mocker.js